export const ComplienceClipboard = ({ size = "16" }: { size?: string }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_264_7153)">
      <path
        d="M15.0867 8.73564L12.3333 7.82231L9.58 8.73564C9.034 8.91697 8.66667 9.42497 8.66667 9.99964V12.6076C8.66667 14.9863 11.1427 16.4096 11.902 16.789L12.3047 16.9903L12.7227 16.8223C13.492 16.513 16.0007 15.295 16.0007 12.6076V9.99964C16.0007 9.42497 15.6333 8.91697 15.0873 8.73564H15.0867ZM14.6667 12.607C14.6667 14.3283 13.0507 15.2236 12.3633 15.5256C11.7527 15.1983 10 14.1263 10 12.607V10.001L12.3333 9.22697L14.6667 9.99897V12.607ZM9.33333 6.93164H2.66667V5.59831H9.33333V6.93164ZM7.33333 9.59831H2.66667V8.26497H7.33333V9.59831ZM2.66667 10.9316H7.33333V12.265H2.66667V10.9316ZM9.67333 16.9316H2C0.897333 16.9316 0 16.0343 0 14.9316V2.26497H3.44733C3.72267 1.48897 4.464 0.931641 5.33333 0.931641H6.66667C7.536 0.931641 8.27733 1.48897 8.55267 2.26497H12V6.52831L10.6667 6.97031V3.59831H7.33333V2.93164C7.33333 2.56431 7.034 2.26497 6.66667 2.26497H5.33333C4.966 2.26497 4.66667 2.56431 4.66667 2.93164V3.59831H1.33333V14.9316C1.33333 15.299 1.63267 15.5983 2 15.5983H8.36933C8.76333 16.1276 9.22467 16.5716 9.67333 16.9316Z"
        fill="#706A85"
      />
    </g>
    <defs>
      <clipPath id="clip0_264_7153">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.931641)"
        />
      </clipPath>
    </defs>
  </svg>
);
